<template>
  <div class="header-wrapper">
    <div
      class="header-pc-wrapper"
      @mouseenter.stop="toggleFade"
      @mouseleave="toggleFade"
      :class="{ 'hover-active': fade }"
    >
      <!-- :class="{'header-active' : headerFixed, 'hover-active' : fade}" -->
      <div class="header-main-pc">
        <div class="logo-main">
          <router-link class="link-index" to="/">
            <img src="/static/images/logo/logo.png" alt="" />
          </router-link>
        </div>
        <div class="header-nav">
          <div
            class="nav-list"
            v-for="(value, index) in $t('header.list')"
            :key="index"
          >
            <div
              class="nav-parent"
              v-if="value.children"
              @mouseenter="toggleSlide(index)"
              @mouseleave="toggleSlide"
            >
              <div class="parent-item" :id="value.id">{{ value.title }}</div>
              <div
                class="nav-children"
                v-show="show"
                v-if="index === currentIndex"
                :style="{ 'padding-bottom': index === 1 ? '40px' : '0' }"
              >
                <div
                  class="children-item"
                  v-for="(item, index) in value.children.list"
                  :key="index"
                  :style="{ 'align-self': index === 1 ? 'flex-start' : '0' }"
                >
                  <router-link
                    v-if="item.state === 'ICON'"
                    class="children-ICON"
                    :to="item.link"
                    :style="{ 'min-width': value.id == 7 ? '200px' : '100px' }"
                  >
                    <img class="item-icon" :src="item.icon" />
                    <span class="item-text">{{ item.alias }}</span>
                  </router-link>
                  <div class="children-SORT" v-if="item.state === 'SORT'">
                    <div class="item-sort" v-if="item.leaf === 2">
                      <div class="item-title-main">
                        <h2 class="item-title">{{ item.title }}</h2>
                      </div>
                      <div
                        class="item-main"
                        v-for="(item, index) in item.children"
                        :key="index"
                      >
                        <div class="item-title">{{ item.title }}</div>
                        <div
                          class="item-content"
                          v-for="(item, index) in item.list"
                          :key="index"
                        >
                          <router-link class="item-route" :to="item.link">
                            <span class="route-text">{{ item.alias }}</span>
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <div class="item-sort" v-if="item.leaf === 1">
                      <div class="item-title-main">
                        <h2 class="item-title">{{ item.title }}</h2>
                      </div>
                      <div style="height: 20px; margin-bottom: 10px"></div>
                      <div
                        class="item-main clear"
                        v-for="(item, index) in item.children"
                        :key="index"
                      >
                        <div class="item-content">
                          <router-link class="item-route" :to="item.link">
                            <span class="route-text">{{ item.alias }}</span>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                  <router-link
                    v-if="item.state === 'TEXT'"
                    class="children-TEXT"
                    :to="item.link"
                  >
                    <div class="item-text">{{ item.alias }}</div>
                  </router-link>
                </div>
                </div>
              </div>
            </div>
            <div v-else class="nav-parent">
              <router-link
                v-if="value.target === 'self'"
                class="parent-link"
                :to="value.link"
                >{{ value.title }}</router-link
              >
              <!-- 'joinUs' -->
              <a v-else :href="value.link" target="_blank">{{ value.title }}</a>
            </div>
          </div>
        </div>
        <!-- <div class="i18n-main"> -->
        <!-- @click="changeLang" -->
        <!-- <span class="i18n-btn">EN/中</span>
        </div> -->
      </div>
    </div>
    <div class="header-m-wrapper">
      <div
        class="header-main-mobile"
        :class="{ 'header-open': headerOpen, 'header-active': headerFixed }"
      >
        <div class="icon-main-wrapper">
          <v-mtoc
            class="menu-main"
            @openMenu="openMenu"
            :header-open="headerOpen"
            :header-fixed="headerFixed"
          ></v-mtoc>
          <div class="logo-main">
            <router-link class="link-index" to="/">
              <img
                v-if="headerFixed || headerOpen"
                src="/static/images/logo/logo.png"
                alt=""
              />
              <img v-else src="/static/images/logo/logo_base.png" alt="" />
            </router-link>
          </div>
        </div>
        <div
          class="nav-main-wrapper"
          :class="[headerOpen ? 'nav-wrapper-visible' : '']"
        >
          <div
            class="nav-main"
            :class="[secondMenuOpen ? 'transformLeft' : 'transformRight']"
          >
            <div
              class="nav-list"
              v-for="(item, index) in $t('header.listM')"
              :key="index"
            >
              <div
                v-if="item.children"
                class="nav-parent"
                @click.stop="showSecondMenu(index)"
              >
                <div class="parent-item">{{ item.title }}</div>
                <span class="arrow-right"></span>
                <div class="nav-children" v-if="index === currentIndex">
                  <div @click.stop="hideSecondMenu()" class="return-last">
                    return
                  </div>
                  <div
                    class="children-item"
                    v-for="(item, index) in item.children.list"
                    :key="index"
                    @click.stop="closeHeader"
                  >
                    <router-link
                      v-if="
                        item.state === 'ICON' ||
                        item.state === 'IMG' ||
                        item.state === 'TEXT'
                      "
                      class="children-link"
                      :to="item.link"
                      >{{ item.alias }}</router-link
                    >
                    <div class="children-SORT" v-if="item.state === 'SORT'">
                      <router-link
                        class="children-link"
                        v-for="(item, index) in item.list"
                        :key="index"
                        :to="item.link"
                        >{{ item.alias }}</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="nav-parent" @click.stop="closeHeader">
                <router-link class="parent-link" :to="item.link">{{
                  item.title
                }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// 导航调试
// show: true, // 显示二级导航
// currentIndex: 1, // 显示当前item

import mtoc from "@/components/menuToClose/mtoc.vue";
export default {
  props: {
    headerFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      header: [], // 头部导航数据
      fade: false, // 划过导航是否fade
      show: false, // 是否显示二级导航
      currentIndex: null, // 二级导航显示当前item
      headerOpen: false, // -m 点击menu导航打开
      secondMenuOpen: false, // -m 二级导航打开
    };
  },
  methods: {
    toggleFade() {
      this.fade = !this.fade;
    },
    toggleSlide(index) {
      this.show = !this.show;
      this.currentIndex = index;
    },
    // 移动端方法
    openMenu(status) {
      this.headerOpen = status;
      if (!this.headerOpen) this.secondMenuOpen = false;
    },
    showSecondMenu(index) {
      this.currentIndex = index;
      this.secondMenuOpen = true;
    },
    hideSecondMenu() {
      this.secondMenuOpen = false;
    },
    closeHeader() {
      this.headerOpen = this.secondMenuOpen = false;
    },
    changeLang() {
      if (this.$i18n.locale === "zh_CN") {
        this.$i18n.locale = "en_US";
      } else {
        this.$i18n.locale = "zh_CN";
      }
    },

  },
  components: {
    "v-mtoc": mtoc,
  },
};
</script>

<style scoped lang="stylus">
@media screen and (min-width: 769px) {
  .header-wrapper {
    min-width: 1200px;
    margin: 0 auto;
    height: 66px;

    .header-pc-wrapper {
      width: 100%;
      height: 66px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1000;
      font-size: 16px;
      color: #111111;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      transition: all 0.1s ease-in-out;

      &.header-active {
        position: fixed;
        background: #fff;
      }

      &.hover-active {
        transition: all 0.1s ease-in-out;
        background: rgba(255, 255, 255, 1);
      }

      .header-main-pc {
        max-width: 1280px;
        margin: 0 auto;
        height: 100%;
        display: flex;
        box-sizing: border-box;

        .logo-main {
          .link-index {
            display: inline-block;
            height: 36px;
            padding: 15px 0;
            text-align: center;
          }
        }

        .header-nav {
          flex: 1;
          width: 100%;
          height: 100%;
          padding-right: 2rem;
          display: flex;
          justify-content: flex-end;

          .nav-list {
            display: inline-block;
            min-width: 70px;
            padding: 0 0.25rem;
            text-align: center;

            &:hover {
              color: #2D70C0;
            }

            &:nth-last-child(1), &:nth-last-child(2) ,&:nth-last-child(3){
              .nav-parent {
                position: relative;

                .nav-children {
                  width: 144px;
                  left: 50%;
                  margin-left: -72px;
                  border: none;
                  flex-direction: column;

                  .children-item {
                    width: 100%;
                    line-height: 40px;
                    color: #111111;

                    &:hover {
                      background: #DEE6EE;
                      border-radius: 4px;
                    }

                    a {
                      display: block;
                      width: 100%;
                      height: 100%;
                    }
                  }
                }
              }
            }

            .nav-parent {
              text-align: center;
              line-height: 66px;
              cursor: pointer;

              a:hover {
                color: #2D70C0;
              }

              .nav-children {
                position: absolute;
                left: 0;
                top: 66px;
                z-index: 999;
                width: 100%;
                background: rgba(255, 255, 255, 1);
                border-top: 1px solid #B4C3D9;
                border-bottom: 1px solid #B4C3D9;
                box-shadow: 0 20px 40px 0 rgba(138, 158, 189, 0.3);
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;

                .children-item {
                  .children-ICON {
                    display: inline-block;
                    min-width: 100px;
                    height: 190px;
                    margin: 5px;
                    border-radius: 4px;

                    &:hover {
                      background: #F5F7FA;

                      .item-text {
                        color: #111111;
                      }
                    }

                    .item-icon {
                      width: 36px;
                      height: 36px;
                      margin-top: 63px;
                    }

                    .item-text {
                      display: block;
                      width: 100%;
                      line-height: 0;
                      color: #333333;
                      text-align: center;
                    }
                  }

                  .children-SORT {
                    padding: 0 0.2rem;
                    box-sizing: border-box;
                    text-align: left;
                    vertical-align: top;

                    .item-sort {
                      width: 480px;

                      .item-title-main {
                        height: 26px;
                        line-height: 26px;
                        margin-top: 30px;
                        margin-bottom: 10px;
                        position: relative;

                        .item-title {
                          font-size: 18px;
                          font-weight: 600;
                          color: #111111;
                          position: absolute;
                          left: 0;
                          top: 0;
                          z-index: 1000;
                        }
                      }

                      .item-main {
                        float: left;
                        vertical-align: top;

                        .item-title {
                          height: 20px;
                          font-size: 14px;
                          font-weight: 600;
                          color: #777777;
                          line-height: 20px;
                          margin-bottom: 10px;
                        }

                        .item-content {
                          text-align: left;

                          .item-route {
                            display: block;
                            width: 240px;
                            height: 46px;
                            line-height: 46px;
                            border-radius: 4px;

                            &:hover {
                              background: #F5F7FA;
                            }

                            .route-text {
                              padding-left: 20px;
                              line-height: 46px;
                              color: #111111;
                              font-size: 14px;
                              vertical-align: top;
                            }
                          }
                        }
                      }

                      .clear {
                        clear: both;
                      }
                    }
                  }

                  .children-IMG {
                    display: inline-block;
                    width: 250px;
                    height: 140px;
                    margin: 40px 5px;
                    border-radius: 4px;
                    background: #FDFDFE;

                    &:hover {
                      background: #F5F7FA;
                    }

                    .item-text {
                      line-height: 40px;
                      color: #111111;
                      vertical-align: top;
                    }
                  }

                  .children-TEXT {
                  }
                }
              }

              .parent-link {
                display: inline-block;
                width: 100%;
                height: 100%;
                color: #111111;

                &:hover {
                  color: #2D70C0 !important;
                }
              }
            }
          }
        }

        .i18n-main {
          position: absolute;
          width: 100px;
          height: 100%;
          right: 20px;
          top: 0;
          text-align: center;
          font-size: 14px;
          cursor: pointer;

          .i18n-btn {
            display: inline-block;
            height: 36px;
            font-size: 16px;
            padding: 15px 0;
            line-height: 36px;
          }
        }
      }
    }

    .header-m-wrapper {
      display: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .header-wrapper {
    height: 0.5rem;

    .header-m-wrapper {
      width: 100%;
      height: auto;
      font-size: 0.16rem;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999999;

      .header-main-mobile {
        height: 0.68rem;
        position: relative;
        background: rgba(0, 0, 0, 1);
        border-bottom: 1px solid rgba(0, 0, 0, 1);
        transition: all 0.5s ease-in-out;

        &.header-open {
          border-bottom: 1px solid #f2f2f2;
          transition: all 0.5s ease-in-out;
          background: rgba(255, 255, 255, 1);
        }

        &.header-active {
          height: 0.5rem;
          border-bottom: 1px solid #f2f2f2;
          background: rgba(255, 255, 255, 1);
          transition: all 0.5s ease-in-out;
        }

        .icon-main-wrapper {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 0.5rem;
          z-index: 999;

          .menu-main {
            width: 0.22rem;
            height: 0.24rem;
            padding: 0.12rem 0 0 0.12rem;
          }

          .logo-main {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 138px;
            height: 36px;

            .link-index {
              display: inline-block;
              width: 100%;
              height: 100%;
              text-align: center;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .nav-main-wrapper {
          position: fixed;
          left: 0;
          top: 0;
          width: 100%;
          height: 0.5rem;
          overflow: hidden;
          background: #fff;
          opacity: 0;
          z-index: 400;
          transition: all 0.3s ease-in-out;

          &.nav-wrapper-visible {
            top: 0.5rem;
            height: 100%;
            opacity: 1;
            transition: all 0.5s ease-in-out;
          }

          .nav-main {
            height: auto;
            transform: translate3d(0, 0, 0);

            &.transformLeft {
              transform: translate3d(-100%, 0, 0);
              transition: all 0.5s ease-in-out;
            }

            &.transformRight {
              transform: translate3d(0, 0, 0);
              transition: all 0.5s ease-in-out;
            }

            .nav-parent {
              position: relative;
              padding: 23px 20px 22px;
              border-bottom: 1px solid #f2f2f2;

              .nav-children {
                width: 100%;
                position: fixed;
                left: 100%;
                top: 0;
                background: #fff;

                .return-last {
                  display: block;
                  padding: 18px 20px 17px;
                  border-bottom: 1px solid #f2f2f2;
                  background: #F5F7FA;
                }

                .children-item {
                  .children-SORT {
                    .children-link {
                      display: block;
                      padding: 23px 20px 22px;
                      border-bottom: 1px solid #f2f2f2;
                    }
                  }

                  .children-link {
                    display: block;
                    padding: 23px 20px 22px;
                    border-bottom: 1px solid #f2f2f2;
                  }
                }
              }

              .arrow-right {
                position: absolute;
                right: 0.2rem;
                top: 50%;
                margin-top: -11px;

                &:before {
                  content: '>';
                  display: block;
                  height: 22px;
                  width: 22px;
                  text-align: center;
                  line-height: 22px;
                }
              }

              .parent-link {
                display: block;
              }
            }
          }
        }
      }
    }

    .header-pc-wrapper {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue